module.exports = __webpack_public_path__ + "61194cd1f831894715a33f978e67c343.svg";